import {
  Autocomplete,
  Box,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  Radio,
  RadioGroup,
  Stack,
  SwipeableDrawer,
  Tab,
  Tabs,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect, useMemo } from "react";
import LeadPersonalDetailsStyles from "./LeadPersonalDetails.styles";
import CustomButton from "../../../../../global/components/CustomButton/CustomButton";
import DescriptionIcon from "@mui/icons-material/Description";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CustomInput from "../../../../../global/components/CustomInput/CustomInput";
import { handleValidation, validateInput } from "./Validation";
import {
  openErrorNotification,
  isTruthy,
  openSuccessNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import {
  DataGridPro,
  GridColDef,
  GridRenderCellParams,
} from "@mui/x-data-grid-pro";
import {
  assignToMembers,
  changeAt,
  changeStage,
  deleteReminder,
  getAllForms,
  getAllLeadHistory,
  getAllSource,
  getAllStage,
  getAllTeamData,
  getAllTeamMembersData,
  getAllUsers,
  getFormByID,
  getReminder,
  saveReminder,
} from "../../ShowAll/ShowAllService";
import { getTeamList } from "../../../../MetaData/components/MetaList/components/AddTeamMetaList/CreateService";
import { store } from "../../../../../utils/store";
import {
  getAllMyLead,
  getRemark,
  saveRemark,
} from "../../../../MyLead/components/ShowAll/ShowAllService";
import { RegisterEmployee, updatePersonalDetail } from "../StepperService";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import customTableStyles from "../../../../../global/components/CustomTable/customTable.styles";
import { addTask, getTask } from "./PersonalDetailsService";
import CustomAutoComplete from "../../../../../global/components/CustomAutoComplete/CustomAutoComplete";
import customInputStyles from "../../../../../global/components/CustomInput/CustomInput.styles";
import {
  DateField,
  DatePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CustomPageHeaderStyles from "../../../../../global/components/CustomPageHeader/CustomPageHeader.styles";
import dayjs, { Dayjs } from "dayjs";
import { Panorama } from "aws-sdk";
import CloseIcon from "@mui/icons-material/Close";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { log } from "console";
import { AnyArn } from "aws-sdk/clients/groundstation";
import { clickToCall } from "../../../../Team/components/ShowAll/ShowAllService";
interface CustomProps {
  nextStep?: () => void | undefined;
  userId: string;
  setUserId?: Function;
  fromSettingOrLogout?: any;
  addNewTeamDialog: any;
  eventForEdit: any;
  handleCloseAddTeam: Function;
  leadData: any;
  stageData: any;
  formName: any;
  stageSourse: any;
  responseValuereminder: any;
  responseValueremark: any;
  selectedOptions: any;
  type: any;
  // leadOption:any;
  allSatgedata: any;
  addinationalValue: any;
  /** Hide "Lead Info" bar + Previous/Next (full-page details route) */
  hideNavHeader?: boolean;
}

function LeadPersonalDetails(props: CustomProps) {
  const classes = LeadPersonalDetailsStyles;
  const customTableClasses = customTableStyles;

  const { leadData, responseValuereminder, responseValueremark, allSatgedata } =
    props;
  // const [inputValue, setInputValue] = useState(
  //   personalDetailState?.formId?.value ?? ""
  // );
  const [personalDetailState, setPersonalDetailState] = useState<any>(leadData);
  const [currentLeadIndex, setCurrentLeadIndex] = useState<number>(0);
  const [formFielsAns, setFormFielsAns] = useState<any>([]);
  const [activeButton, setActiveButton] = useState("Previous");
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const [formFiels, setFormFiels] = useState<any>([]);
  const [formName, setFormName] = useState<any>([]);
  const [leadHistory, setLeadHistory] = useState<any>([]);
  // const [stageSourse, setStageSourse] = useState<any>([]);
  const [state, setState] = useState([]);
  const [apiResponse, setApiResponse] = useState(false);
  // const [stageData, setStageData] = useState<any>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [openReminder, setOpenReminder] = React.useState(false);
  const [openRemarkPop, setRemarkPop] = React.useState(false);
  const [titleReminder, setTitleReminder] = useState("");
  const [dateTimeReminder, setDateTimeReminder] = useState("");
  const [noteReminder, setNoteReminder] = useState("");
  const [showAll, setShowAll] = useState(false);
  const [noteRemarkValue, setnoteRemarkValue] = useState("");
  const [selectedTab, setSelectedTab] = useState(
    props.type === "reminder" ? 3 : props.type === "note" ? 4 : 0
  );
  const [taskData, setTaskData] = useState<any>([]);
  const [taskDrawer, setTaskDrawer] = useState(false);
  const [value, setValue] = React.useState<string | null>();
  const [taskState, setTaskState] = useState<any>({});
  const [errors, setErrors] = useState<{
    // assignTo: boolean;
    assignToMember: boolean;
    priority: boolean;
  }>({
    // assignTo: false,
    assignToMember: false,
    priority: false,
  });
 const handleTabChange = async (
    newValue: any
  ) => {
    setSelectedTab(newValue);
    if (newValue === 2) {
      const response = await getTask(leadData._id);
      setTaskData(response.data);
    } else if (newValue === 3) {
      const response = await getReminder(leadData._id);
      setRowReminder(response.data)

    }
    else if (newValue === 4) {
      const response = await getRemark(leadData._id);  
      setrowRemarks(response.data)
    }
  };
useEffect(()=>{
handleTabChange(selectedTab)
},[selectedTab])


  const handleClickLeads = async (direction: "Previous" | "Next") => {
    const leadArray = Array.isArray(response) ? response : response?.data || [];
    // console.log("Response Data:", response);
    // console.log("Current Index Before Update:", currentLeadIndex);
    // console.log("Lead Array:", leadArray);
    if (!leadArray || leadArray.length === 0) {
      console.error("No lead data available!");
      return;
    }

    let newIndex = currentLeadIndex;
    if (direction === "Next") {
      if (currentLeadIndex < leadArray.length - 1) {
        newIndex++;
      } else {
        newIndex = 0;
      }
    }
    if (direction === "Previous") {
      if (currentLeadIndex > 0) {
        newIndex--;
      } else {
        newIndex = leadArray.length - 1;
      }
    }
    console.log("New Index After Update:", newIndex);
    setCurrentLeadIndex(newIndex);
    setActiveButton(direction);
    console.log("Current Lead Data:", leadArray[newIndex]);
    const selectedLead = leadArray[newIndex];
    setPersonalDetailState(selectedLead);
    console.log(selectedLead._id, "selectedLead._idselectedLead._id");

    try {
      const historyResponse = await getAllLeadHistory(selectedLead._id);
      setLeadHistory(historyResponse.data);
      const resTask = await getTask(selectedLead._id);
      setTaskData(resTask.data);
    } catch (error) {
      console.error("Error fetching lead history:", error);
    }
  };
  console.log();

  const flattenStageData = (
    data: any[]
  ): { label: string; isParent: boolean }[] => {
    const result: { label: string; isParent: boolean }[] = [];

    const extractStageNames = (stages: any[]) => {
      stages.forEach((stage) => {
        if (stage.stage_Name) {
          result.push({ label: stage.stage_Name, isParent: true }); // Parent entry
        }
        if (stage.sub_Stage_name && Array.isArray(stage.sub_Stage_name)) {
          stage.sub_Stage_name.forEach((subStage: any) => {
            result.push({ label: subStage.stage_Name, isParent: false }); // Child entry
          });
        }
      });
    };

    extractStageNames(data);
    return result;
  };

  const stageOptions = flattenStageData(allSatgedata);

  const handleSubmit = async () => {
    const hasPriorityError = !taskState.priority;
    // const hasAssignToError = !taskState.assignTo;
    const hasAssignToMemberError = !taskState.assignToMember;
    if (hasPriorityError  || hasAssignToMemberError) {
      setErrors({
        priority: hasPriorityError,
        // assignTo: hasAssignToError,
        assignToMember: hasAssignToMemberError,
      });
      return;
    }
    const payload = {
      leadId: leadData._id,
      userId: JSON.stringify([store.getState().auth.userId, taskState.assignToMember]),

      priority: taskState.priority,
      assignTo: JSON.stringify(selectedOptions?.map((val: any) => val.id)),
      assignToMember: JSON.stringify(taskState.assignToMember),
      dueDate: taskState.dueDate,
      closedDate: taskState.closedDate,
      description: taskState.description,
    };
    console.log(payload, "payload:::::::::::::");
    const response = await addTask(payload);
    if (response.success === 1) {
      console.log(personalDetailState._id);
      const data = await getTask(personalDetailState._id);
      setTaskData(data.data);
      closeDrawer();
    }
  };
  const handleCheckboxChange = (optionId: string) => {
    const currentAssignToMember = taskState?.assignToMember || [];
    const updatedMembers = currentAssignToMember?.includes(optionId)
      ? currentAssignToMember?.filter((id: string) => id !== optionId)
      : [...currentAssignToMember, optionId];

    setTaskState((prev: any) => ({
      ...prev,
      assignToMember: updatedMembers,
    }));
  };
  const closeDrawer = () => {
    setTaskDrawer(false);
    setTaskState("");
    setErrors({
      // assignTo: false,
      assignToMember: false,
      priority: false,
    });
  };
  const handleTabChange2 = async (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setSelectedTab(newValue);
    if (newValue === 2) {
      const response = await getTask(leadData._id);
      setTaskData(response.data);
    } else if (newValue === 3) {
      const response = await getReminder(leadData._id);
      console.log(response.data,"bdsncsdvsdsdh")
      setRowReminder(response.data)

    }
    else if (newValue === 4) {
      const response = await getRemark(leadData._id);  
      setrowRemarks(response.data)
    }
  };
  const [dynamicGridValue, setDynamicGridValue] = useState<any>({
    row: { ...leadData },
  });
  const [selectedOptions, setSelectedOptions] = useState<any>([]);
  const [leadOptionMembers, setLeadOptionMembersas] = useState<any>([]);
  const [selectedOptionsMembers, setSelectedOptionsMembers] = useState<any>([]);
  console.log(selectedOptionsMembers, "selectedOptions");

  const [reminderStatus, setReminderStatus] = useState<any>("");
  const currentDateTime = new Date().toISOString().slice(0, 16);
  const [reminderData, setReminderData] = useState<any>({
    date: currentDateTime,
  });
  // const [addinationalValue, setaddinationalValue] = useState<any>(addinationalValue);
  const [fixData, setFixData] = useState<any[]>([]);
  const [teamList, setTeamList] = useState<any>([]);
  const [stageData, setStageData] = useState<any>([]);
  const [stageSourse, setStageSourse] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [offialDetailState, setOffialDetailState] = useState<any>({});
  const [paginationModel, setPaginationModel] = React.useState({
    pageSize: 25,
    page: 0,
  });
  const [response, setResponse] = useState<any>();
  const [metaData, setMetaData] = useState<any>({
    total: 1,
    page: 0,
  });

  const [idForTeam, setIdForTeam] = useState<any>([]);
  const [idForMember, setIdForMember] = useState<any>([]);
  const [leadOption, setLeadOption] = useState<any>([]);
  // const [rowReminder, setRowReminder] = useState<any>(responseValuereminder?.value);
  // console.log(rowReminder,"rowReminder")
  // const [rowRemarks, setrowRemarks] = useState<any>(responseValueremark?.value || []);
    const [rowReminder, setRowReminder] = useState<any>([]);
  const [rowRemarks, setrowRemarks] = useState<any>([]);

  // const rowReminder = useMemo(
  //   () => responseValuereminder?.value || [],
  //   [responseValuereminder]
  // );
  console.log(rowReminder,"rowReminderrowReminder")
  // const rowRemarks = useMemo(
  //   () => responseValueremark?.value || [],
  //   [responseValuereminder]
  // );
  const uniqueLeadOptionMembers = Array.from(
    new Map(leadOptionMembers?.map((member:any) => [member.id, member])).values()
  );
  
  const handelDropdown = async (id: any) => {
    console.log(id,"idd::::::::::::::")
    
    try {
      setApiResponse(true);
      const response1 = await getAllTeamData(id)
      const assignToData =  response1.data.flatMap((team: any) => {
        const subTeams = team.sub_teams?.map((subTeam: any) => 

          ({
          
          id: subTeam._id,
          label: subTeam.team_name,
          selected: subTeam?.is_available,
          isParent:false,
          teamMembers: subTeam.team_members.length
          ? subTeam.team_members.map((member: any) => {
              return {
                id: member.userId,
                label: member.users[0].name,
                selected: 0,
              };
            })
          : null,
         
        })) || [];
    
        const mainTeam = {
          id: team._id,
          label: team.team_name,
          selected: team?.is_available,
          isParent:true,
          teamMembers: team.team_members.length
          
          ? team.team_members.map((member: any) => {
              return {
                id: member.userId,
                label: member.users[0].name,
                selected: 0,
              };
            })
          : null,
        };
        return [mainTeam, ...subTeams];
      })
      setLeadOption(
        assignToData
      );

      const selectedData = assignToData
        .filter((e: any) => {
          return e?.selected == 1;
        })
        .map((e: any) => {
          console.log(e, "Processing in map");
          return {
            id: e.id,
            label: e.label,
            selected: e?.selected,
            teamMembers: Array.isArray(e.teamMembers)
              ? e.teamMembers.map((member: any) => ({
                id: member.id,
                label: member.label,
                selected: 0,
              }))
              : null,
          };
        });

      setSelectedOptions(
        selectedData
      );

    
      const ids = assignToData
        .filter((e: any) => e?.selected === 1)
        .map((e: any) => e.id);
      if (ids) {
        handelDropdownAfterSelect(ids,id);
      }
    } catch {
    } finally {
      setApiResponse(false);
    }
  };
  // const handelDropdown = async (id: any) => {
  //   try {
  //     const response1 = await getAllTeamData(id);
  //     setLeadOption(
  //       response1.data?.map((e: any) => {
  //         return {
  //           id: e._id,
  //           label: e.team_name,
  //           selected: e?.is_available,
  //           teamMembers: e.team_members.length
  //             ? e.team_members.map((member: any) => {
  //                 return {
  //                   id: member.userId,
  //                   label: member.users[0].name,
  //                   selected: 0,
  //                 };
  //               })
  //             : null,
  //         };
  //       })
  //     );
  //     setSelectedOptions(
  //       response1.data
  //         ?.filter((e: any) => e?.is_available === 1)
  //         ?.map((e: any) => {
  //           return {
  //             id: e._id,
  //             label: e.team_name,
  //             selected: e?.is_available,
  //             teamMembers: e.team_members.length
  //               ? e.team_members?.map((member: any) => {
  //                   return {
  //                     id: member.userId,
  //                     label: member.users[0].name,
  //                     selected: 0,
  //                   };
  //                 })
  //               : null,
  //           };
  //         })
  //     );

  //     const ids = response1.data
  //       ?.filter((e: any) => e?.is_available === 1)
  //       .map((e: any) => e._id);

  //     if (ids) {
  //       handelDropdownAfterSelect(ids);
  //     }
  //   } catch {}
  // };
  useEffect(() => {
    tableDataShowHandler();
  }, []);
  // useEffect(() => {
  //   if(selectedTab === 3){
  //     const res = await getReminder(dynamicGridValue.row._id);
  //   }
  //   else if(selectedTab === 4){
  //     const response = await getRemark(leadData._id);
  //   }
  // }, [selectedTab]);

  useEffect(() => {
    if (!openReminder) {
      setTitleReminder("");
      setDateTimeReminder("");
      setNoteReminder("");
    }
  }, [openReminder]);

  useEffect(() => {
    if (!openRemarkPop) {
      setnoteRemarkValue("");
    }
  }, [openRemarkPop]);

  useEffect(() => {
    handelDropdown(leadData._id);
  }, [leadData._id]);

  useEffect(() => {
    handleGetAllLeadHistory();
  }, []);

  const handleButtonClickleads = (button: any) => {
    console.log(response, "response55");
    setActiveButton(button);
  };

  const handleGetAllLeadHistory = async () => {
    try {
      const response = await getAllLeadHistory(personalDetailState._id);
      setLeadHistory(response.data);
    } catch (error) {}
  };
  console.log(leadHistory, "leadHistoryleadHistoryleadHistory");

  const tableDataShowHandler = async () => {
    console.log(personalDetailState,"props.eventForEditprops.eventForEdit")
    try {
      setApiResponse(true);
      const response20 = await getTeamList();
      setTeamList([
        {
          team_id: "All",
          team_name: "All",
        },
        ...response20?.data?.map((e: any) => {
          return {
            team_id: e?._id,
            team_name: e?.team_name,
          };
        }),
      ]);
      const response2 = await getAllStage();
      const val = response2.data?.map((e: any) => {
        return e.status_name;
      });
      setStageData(val?.filter((name: any) => name !== "Initial"));

      const response3 = await getAllSource();

      setStageSourse(
        response3.data?.map((e: any) => {
          return e.source_name;
        })
      );
      const response4 = await getAllForms();
      const response5 = await getFormByID(leadData.formId);

   
      setFormName(
        response4.data?.map((i: any) => {
          return { id: i._id, label: i.form_name };
        })
      );
      const payload = {
        userId: store.getState().auth.userId,
        lead_id: offialDetailState.team_id?.id,
        pageNo: paginationModel.page,
        pageSize: paginationModel.pageSize,
      };
      let response = []
      if(props.type === "MyLead"){
          response = await getAllMyLead(payload)
      }else{
        
         response = await getAllUsers(payload);
      }
      console.log(response,"responseresponseresponse")
      // setFormFiels((prevFormDataFields: any) => ({
      //   ["fieldData"]: personalDetailState?.dynamicFields,
      // }));
      setFormFiels((prevFormDataFields: any) => {
        const existingFields = personalDetailState?.dynamicFields || [];
      
        // Filter out values in response4.dynamicFields that already exist in existingFields
        const newFields = response5.data.dynamicFields.filter(
          (field:any) => !existingFields.some((existing:any) => existing.id === field.id)
        );
      
        return { fieldData: [...existingFields, ...newFields] };
      });


      // setLoading(true);
      setResponse(response.data);
      setMetaData(response?.metadata[0] ? response?.metadata[0] : metaData);
      // const source = response.data?.map((userData: any, index: any) => {
      //   return {
      //     lead: (
      //       <>
      //         <Typography sx={classes.headerName}>
      //           {userData?.leadName}
      //         </Typography>
      //         <Typography sx={classes.headerName}>{userData?.uid}</Typography>
      //       </>
      //     ),
      //     // reminder: <>{getReminderInfo(userData._id)}</>,
      //     property: (
      //       <>
      //         <Typography sx={classes.subHeaderName}>
      //           {userData.projecttypeId}
      //         </Typography>
      //       </>
      //     ),
      //     contact: (
      //       <Typography sx={classes.subHeaderName}>
      //         {userData.leadEmail},{userData.leadPhone} <br />{" "}
      //         {userData.leadPhone}{" "}
      //       </Typography>
      //     ),
      //     formName: (
      //       <Typography sx={classes.subHeaderName}>
      //         {userData?.form_name}
      //       </Typography>
      //     ),
      //     source: (
      //       <>
      //         <Typography sx={classes.subHeaderName}>
      //           {userData?.source}
      //         </Typography>
      //       </>
      //     ),
      //     stage: (
      //       <>
      //         {userData.AssignToUserStage}
      //         {/* <Autocomplete
      //           disableClearable
      //           inputValue={userData?.stage ?? ""}
      //           onChange={(event: any, newValue: string | null) => {
      //             handleAutocompleteChange("formId", newValue || "", userData);
      //           }}
      //           id="controllable-states-demo"
      //           options={stageData}
      //           sx={classes.autocomplateStyle}
      //           renderInput={(params) => (
      //             <TextField
      //               sx={classes.autoInputFill}
      //               {...params}
      //               placeholder="select your form name"
      //             />
      //           )}
      //           renderOption={(props, option) => {
      //             return (
      //               <li {...props}>
      //                 <span style={{ display: "none" }}>{option}</span>
      //                 {option}
      //               </li>
      //             );
      //           }}
      //         /> */}
      //       </>
      //     ),
      //     at: (
      //       <>
      //         {((userData?.AssignTo && userData?.AssignTo) || [])?.map(
      //           (item: any) => {
      //             <Typography>{item.team_name}</Typography>;
      //           }
      //         )}
      //       </>
      //     ),
      //     action: (
      //       <>
      //         {/* <Box sx={classes.verticalDotButton}>
      //           <Button
      //             onClick={(event: any) =>
      //               handlePopOver(
      //                 event,
      //                 userData.formId,
      //                 userData.status,
      //                 userData
      //               )
      //             }
      //           >
      //             <VerticalDotIcon />
      //           </Button>
      //         </Box> */}
      //       </>
      //     ),
      //   };
      // });
      const arr = new Array(20);
      // setUserDataSource([...source]);
      const source1 = response.data?.map((userData: any) => {
        return userData;
      });
      // setUserDataSource1([...source1]);
      // setFixData([...source]);
      setApiResponse(false);
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  // const rowReminder = responseValuereminder?.value || [];

  // const rowRemarks = responseValueremark?.value || [];

  const handleAutocompleteChangeNew = async (
    name: string,
    value: any,
    data: any
  ) => {
    if (name === "stage") {
      const body = {
        ["id"]: data?._id,
        ["stage"]: value,
      };
      try {
        setApiResponse(true);
        const response = await changeStage(body);
        if (response.success === 1) {         
          setSelectedTab(0)          
          const historyResponse = await getAllLeadHistory(personalDetailState._id);
          setLeadHistory(historyResponse.data);
        }
        tableDataShowHandler();
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }

    if (name === "assignTo") {
      const body = {
        ["id"]: data?._id,
        ["AssignTo"]: value?.id,
      };
      try {
        setApiResponse(true);
        const response = await changeAt(body);

        tableDataShowHandler();
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
    if (name === "formName") {
      if (value.label == "All") {
        tableDataShowHandler();
      }
      let data = response?.filter((e: any) => {
        return e.formId === value.id;
      });

      const source = data?.map((userData: any) => {
        return {
          lead: (
            <>
              <Typography sx={classes.headerName}>{userData?.uid}</Typography>
              <Typography sx={classes.headerName}>
                {userData?.leadName}
              </Typography>
            </>
          ),
          // reminder: <>{getReminderInfo(userData._id)}</>,
          property: (
            <>
              <Typography sx={classes.subHeaderName}>
                {userData.projecttypeId}
              </Typography>
            </>
          ),
          contact: (
            <Typography sx={classes.subHeaderName}>
              {userData.leadEmail},{userData.leadPhone} <br />{" "}
              {userData.leadPhone}{" "}
            </Typography>
          ),
          formName: (
            <Typography sx={classes.subHeaderName}>
              {userData?.form_name}
            </Typography>
          ),
          source: (
            <>
              <Typography sx={classes.subHeaderName}>
                {userData?.source}
              </Typography>
            </>
          ),
          stage: (
            <>
              <Autocomplete
                disableClearable
                inputValue={userData?.stage ?? ""}
                onChange={(event: any, newValue: string | null) => {
                  handleAutocompleteChange("formId", newValue || "");
                }}
                id="controllable-states-demo"
                options={stageData}
                sx={classes.autocomplateStyle}
                renderInput={(params) => (
                  <TextField
                    sx={classes.autoInputFill}
                    {...params}
                    placeholder="select your form name"
                  />
                )}
                renderOption={(props, option) => {
                  return (
                    <li {...props}>
                      <span style={{ display: "none" }}>{option}</span>
                      {option}
                    </li>
                  );
                }}
              />
            </>
          ),
          at: (
            <>
              {(userData.AssignTo ? userData.AssignTo : [])?.map(
                (item: any) => {
                  <Typography>{item.team_name}</Typography>;
                }
              )}
              {(userData.AssignToUser ? userData.AssignToUser : [])?.map(
                (item: any) => {
                  <Typography>{item?.name}</Typography>;
                }
              )}
            </>
          ),
          action: (
            <>
              {/* <Box sx={classes.verticalDotButton}>
                <Button
                  onClick={(event: any) =>
                    handlePopOver(
                      event,
                      userData.formId,
                      userData.status,
                      userData
                    )
                  }
                >
                  <VerticalDotIcon />
                </Button>
              </Box> */}
            </>
          ),
        };
      });
      // setUserDataSource([...source]);
      const source1 = data?.map((userData: any) => {
        return userData;
      });
      // setUserDataSource1([...source1]);
      setFixData([...source]);
      setApiResponse(false);
    }
  };

  const handleAutocompleteChangeCustom = (newValue: any) => {
    const newlySelectedOptions = newValue?.filter(
      (option: any) =>
        !selectedOptions.some(
          (selectedOption: any) => selectedOption.id === option.id
        )
    );
    const removedOptions = selectedOptions.filter(
      (option: any) =>
        !newValue.some((newOption: any) => newOption.id === option.id)
    );
    newlySelectedOptions.forEach((option: any) => {
      const ids = [option.id, ...selectedOptions?.map((e: any) => e.id)];
      handelDropdownAfterSelect(ids);
      setIdForTeam((prev: any) => [...prev, option.id]);
      const opt = { ...option, selected: 1 };
      const objIndex = leadOption.findIndex(
        (item: any) => item.id === option.id
      );
      leadOption[objIndex] = opt;
      // setLeadOption((prev: any) => [...prev, opt]);
      if (option.teamMembers) {
        setLeadOptionMembersas((prev: any) => [
          ...prev,
          ...option.teamMembers.map((member: any) => ({
            pId: option.id,
            id: member.id,
            label: member.label,
            selected: 0,
          })),
        ]);
      }
      setSelectedOptions((prev: any) => [...prev, opt]);
    });
    removedOptions.forEach((option: any) => {
      setSelectedOptions((prev: any) =>
        prev.filter((item: any) => item.id !== option.id)
      );
      setLeadOptionMembersas((prev: any) =>
        prev.filter((item: any) => item.pId !== option.id)
      );
      const opt = { ...option, selected: 0 };
      const objIndex = leadOption.findIndex(
        (item: any) => item.id === option.id
      );
      leadOption[objIndex] = opt;
      // setLeadOption((prev: any) => [...prev]);
      setIdForTeam((prev: any) =>
        prev.filter((item: any) => item !== option.id)
      );
    });
  };
  const handelDropdownAfterSelect = async (ids: any, id: any = null) => {
    try {
      const payload = {
        team_id: ids,
        lead_id: id,
      };
      const response1 = await getAllTeamMembersData(payload);
      const data =
        response1.data.flatMap((member: any) => {
          return (member?.team_members || []).map((mem: any) => {
            if (!mem.users || !mem.users[0]) return null;
            return {
              pId: member._id,
              id: mem.users[0]._id,
              label: mem.users[0]?.name,
              selected: mem?.is_available,
            };
          }).filter(Boolean);
        })

      setLeadOptionMembersas(data
      );
      const members = response1.data
        .flatMap((member: any) => {
          return member?.team_members?.map((mem: any) => {
            return {
              pId: member._id,
              id: mem.users[0]?._id,
              label: mem.users[0]?.name,
              selected: mem?.is_available,
            };
          });
        })
        .filter((item: any) => item.selected === 1);

      setSelectedOptionsMembers(members
      );
    } catch { }
  };
  // const handelDropdownAfterSelect = async (ids: any) => {
  //   try {
  //     const payload = {
  //       team_id: ids,
  //       lead_id: leadData._id,
  //     };
  //     const response1 = await getAllTeamMembersData(payload);
  //     setLeadOptionMembersas(
  //       response1.data.flatMap((member: any) => {
  //         return member?.team_members?.map((mem: any) => {
  //           return {
  //             pId: member._id,
  //             id: mem.users[0]._id,
  //             label: mem.users[0]?.name,
  //             selected: mem?.is_available,
  //           };
  //         });
  //       })
  //     );
  //     setSelectedOptionsMembers(
  //       response1.data
  //         .flatMap((member: any) => {
  //           return member?.team_members?.map((mem: any) => {
  //             return {
  //               pId: member._id,
  //               id: mem.users[0]._id,
  //               label: mem.users[0]?.name,
  //               selected: mem?.is_available,
  //             };
  //           });
  //         })
  //         .filter((item: any) => item.selected === 1)
  //     );
  //   } catch {}
  // };

  const handleOptionCheckboxChange =
    (option: any, value: any) => (event: any, index: any) => {
      if (event.target.checked) {
        const ids = [option.id, ...selectedOptions.map((e: any) => e.id)];
        handelDropdownAfterSelect(ids);
        setIdForTeam((prev: any) => [...prev, option.id]);
        const opt = { ...option, ["selected"]: 1 };
        const objIndex = leadOption.findIndex(
          (item: any) => item.id === option.id
        );
        leadOption[objIndex] = opt;
        // setLeadOption((prev: any) => [...leadOption]);
        if (option.teamMembers) {
          setLeadOptionMembersas((prev: any) => {
            return [
              ...prev,

              ...option.teamMembers.map((member: any) => {
                return {
                  pId: option.id,
                  id: member.id,
                  label: member.label,
                  selected: 0,
                };
              }),
            ];
          });
        }
        setSelectedOptions([...selectedOptions, opt]);
      } else {
        setSelectedOptions(
          selectedOptions.filter((item: any) => item.id !== option.id)
        );
        setLeadOptionMembersas(
          leadOptionMembers.filter((item: any) => item?.pId !== option.id)
        );
        const opt = { ...option, ["selected"]: 0 };
        const objIndex = leadOption.findIndex(
          (item: any) => item.id === option.id
        );
        leadOption[objIndex] = opt;
        // setLeadOption((prev: any) => [...leadOption]);
        setIdForTeam(idForTeam.filter((item: any) => item !== option?.id));
      }
    };

  const handleOptionCheckboxChange1 =
    (option: any, value: any) => (event: any, index: any) => {
      if (event.target.checked) {
        setIdForMember((prev: any) => [...prev, option.id]);
        const opt = { ...option, ["selected"]: 1 };
        const objIndex = leadOptionMembers.findIndex(
          (item: any) => item.id === option.id
        );
        leadOptionMembers[objIndex] = opt;
        setLeadOptionMembersas((prev: any) => [...leadOptionMembers]);
        setSelectedOptionsMembers([...selectedOptionsMembers, opt]);
      } else {
        setSelectedOptionsMembers(
          selectedOptionsMembers.filter((item: any) => item.id !== option.id)
        );
        const opt = { ...option, ["selected"]: 0 };
        const objIndex = leadOptionMembers.findIndex(
          (item: any) => item.id === option.id
        );
        leadOptionMembers[objIndex] = opt;
        setLeadOptionMembersas((prev: any) => [...leadOptionMembers]);
        setIdForMember(idForMember.filter((item: any) => item !== option?.id));
      }
    };
  const handleAssignToMember = (option: any, isChecked: boolean) => {
    console.log(option, isChecked, "isChceked::::::::::::::");
    const updatedOption = { ...option, selected: isChecked ? 1 : 0 };

    // Update the leadOptionMembers state immutably
    const updatedLeadOptions = leadOptionMembers.map((item: any) =>
      item.id === option.id ? updatedOption : item
    );

    setLeadOptionMembersas(updatedLeadOptions);

    // Update selected options
    const updatedSelectedOptions = isChecked
      ? [...selectedOptionsMembers, updatedOption]
      : selectedOptionsMembers.filter((item: any) => item.id !== option.id);

    setSelectedOptionsMembers(updatedSelectedOptions);

    // Update the idForMember array
    const updatedIdForMember = isChecked
      ? [...idForMember, option.id]
      : idForMember.filter((id: any) => id !== option.id);

    setIdForMember(updatedIdForMember);
  };
  const handleChangeRadio = (event: any) => {
    setReminderStatus(event.target.defaultValue);
  };

  const handleDateTimeChange = (event: any) => {
    const selectedDateTime = event.target.value;
    setReminderData((prevFormDataFields: any) => ({
      ...prevFormDataFields,
      ["date"]: event.target.value.split("T")[0],
      ["time"]: event.target.value.split("T")[1],
    }));
  };

  const handelAssignToUser = async (dynamicGridValue: any) => {
    try {
      if (selectedOptionsMembers?.length) {
        const idTeam = selectedOptions?.map((item: any) => {
          return `'${item.id}'`;
        });
        const body1 = {
          ["id"]: dynamicGridValue.row._id,
          ["AssignTo"]: idTeam.join(","),
        };
        // const response2 = await changeAt(body1);
        const idMembers = selectedOptionsMembers?.map((item: any) => {
          return `'${item.id}'`;
        });
        const body = {
          ["id"]: dynamicGridValue.row._id,
          ["AssignToUser"]: idMembers.join(","),
        };

        const response = await assignToMembers(body);
        setIdForMember([]);
        setIdForTeam([]);
        // setSelectedOptionsMembers([]);
        // setSelectedOptions([]);
        // setLeadOptionMembersas([]);
        tableDataShowHandler();
      } else {
        const idTeam = selectedOptions?.map((item: any) => {
          return item.id;
        });
        const idTeamVal = idTeam.reduce(
          (val: any, item: any) => val + "," + `'${item}'`
        );
        const body1 = {
          ["id"]: dynamicGridValue.row._id,
          ["AssignTo"]: idTeamVal,
        };
        const response2 = await changeAt(body1);
        setIdForMember([]);
        setIdForTeam([]);
        setSelectedOptionsMembers([]);
        setSelectedOptions([]);
        setLeadOptionMembersas([]);
        tableDataShowHandler();
      }
    } catch (error: any) {}
  };

  const handelSideSave = async (body: any) => {
    console.log(body, "body");

    try {
      setApiResponse(true);
      const response = await saveReminder(body);
      if (response.success === 1) {
        const res = await getReminder(dynamicGridValue.row._id);
        console.log(res.data,"responseeeeee")
        setSelectedTab(3)
        setRowReminder(res.data);
      }
      setOpenReminder(false);
      tableDataShowHandler();
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handelSideSaveRemark = async (body: any) => {
    const payloade = {
      leadId: body.leadId,
      notes: body.notes_remark,
      // date: new Date().toLocaleDateString(),
      // time: new Date().toLocaleTimeString(),
      date: new Date().toISOString().split("T")[0],
      time: new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" }),
      title: "",
    };
    try {
      setApiResponse(true);
      const response = await saveRemark(payloade);
      if ((response.success === 1)) {
        setSelectedTab(4)
        const response = await getRemark(leadData._id);  
        setrowRemarks(response.data)
        // setDynamicGridValue("");
      }
      setRemarkPop(false);
      setReminderData([]);
      // getRemarkInfo(body.leadId);
      tableDataShowHandler();
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  // const getRemarkInfo = async (id: any) => {
  //   try {
  //     // setApiResponse(true);
  //     const response = await getRemark(id);
  //     if (response.success == 1) {
  //       setResponseValueremark((prevFormData: any) => ({
  //         ...prevFormData,
  //         [id]: {
  //           value: response?.data,
  //         },
  //       }));
  //     }
  //   } catch (error: any) {
  //     setApiResponse(false);
  //     openErrorNotification(
  //       isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
  //     );
  //   }
  // };

  const handelRemoveReminder = async (item: any) => {
    try {
      setApiResponse(true);
      const response = await deleteReminder(item);
      if ((response.sucess = 1)) {
      }
      tableDataShowHandler();
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const firstLetter = personalDetailState.leadName
    ? personalDetailState.leadName
        .split(" ")
        .map((m: any) => {
          const initial = m.charAt(0).toUpperCase();
          return m.length >= 3 ? initial : "";
        })
        .filter(Boolean)
        .slice(0, 2)
        .join("")
    : "";
  const splitLeadName = personalDetailState.leadName
    ? personalDetailState.leadName.split(" ")
    : ["", ""];

  const handleRightDrawerToggle = (open: boolean) => () => {
    setRightDrawerOpen(open);
  };

  const createTask = () => {
    setTaskDrawer(true);
  };

  const handleClose = () => {
    setOpenReminder(false);
    setRemarkPop(false);
  };

  const createReminder = () => {
    setOpenReminder(true);
  };

  const createRemarkPop = () => {
    setRemarkPop(true);
  };

  const handleAutocompleteChange = async (name: string, value: any) => {
    if (name === "formId") {
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        ["formId"]: {
          error: "",
          value: value.label,
          id: value.id,
        },
      }));
      setFormFiels((prevFormDataFields: any) => ({
        ["fieldData"]: props.eventForEdit?.dynamicFields,
      }));
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        data: state.filter((e: any) => {
          return value.id == e._id;
        }),
      }));
    }
    if (name === "selectFiels") {
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          value: value.label,
        },
      }));
    }
  };

  const handleOnChangeInputField = (event: any) => {
    const name: any = event.target.name;
    const value: any = event.target.value;
    const isGoForward: any = validateInput(name, value);
    if (!isGoForward) return;
    setPersonalDetailState((prevFormData: any) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const submitForm = async () => {
    if (personalDetailState?.formId) {
      try {
        const idTeam = (personalDetailState.AssignTo || [])?.map((item: any) => {
          return `'${item._id}'`;
        });
        const idMembers = (personalDetailState.AssignToUser || [])?.map((item: any) => {
          return `'${item._id}'`;
        });
        const body = [
          {
            // ...personalDetailState,
            ["leadName"]: personalDetailState.leadName,
            ["formId"]: personalDetailState.formId,

            // ["dynamicFields"]: formFielsAns.tempList,
            ["leadEmail"]: personalDetailState.leadEmail,
            ["leadPhone"]: personalDetailState.leadPhone,
            ["AssignTo"]: idTeam || "",
            ["AssignToUser"]: idMembers || "",
            ["stage"]: personalDetailState.stage || "",
          ["source"]: personalDetailState.source,
          ["dynamicFields"]:formFielsAns.tempList || personalDetailState.dynamicFields || "",


            ["id"]: personalDetailState._id,
          },
        ];
        console.log(body, "body");
        const response = await updatePersonalDetail(body[0]);
        if (response?.success) {
          openSuccessNotification(response?.message);
          // props.nextStep?.();
          // props.handleCloseAddTeam();
        } else {
          customErrorHandler(response);
        }
      } catch (error: any) {
        openErrorNotification(
          isTruthy(error?.message) ? error?.message : notifiers.GENERIC_ERROR
        );
      }
    } else {
      const validatedObject: any = handleValidation(personalDetailState);
      if (
        validatedObject?.leadName.error ||
        validatedObject.leadPhone.error ||
        validatedObject.leadEmail.error
      ) {
        setPersonalDetailState({ ...validatedObject });
        return;
      }
      try {
        const idTeam = selectedOptions?.map((item: any) => {
          return `'${item.id}'`;
        });
        const idMembers = selectedOptionsMembers?.map((item: any) => {
          return `'${item.id}'`;
        });
        const body = {
          ...personalDetailState?.data[0],
          ["leadName"]: personalDetailState.leadName.value,
          ["formId"]: personalDetailState.formId.id,
          ["dynamicFields"]: personalDetailState.data[0]?.dynamicFields,
          ["leadEmail"]: personalDetailState.leadEmail.value,
          ["leadPhone"]: personalDetailState.leadPhone.value,
          ["AssignTo"]: idTeam.join(",") || "NA",
          ["AssignToUser"]: idMembers.join(",") || "NA",
          ["stage"]: "New",
          ["source"]: personalDetailState.source?.source,
        };
        const response = await RegisterEmployee(body);
        if (response?.success) {
          openSuccessNotification(response?.message);
          // props.handleCloseAddTeam();
          // props?.setUserId && props?.setUserId(response.data._id);
          // setPersonalDetailState(response.data);
          // openSuccessNotification(response?.message);
          // props.nextStep?.();
        } else {
          // customErrorHandler(response);
        }
      } catch (error: any) {
        openErrorNotification(
          isTruthy(error?.message) ? error?.message : notifiers.GENERIC_ERROR
        );
      }
    }
  };
  const handleAutocompleteChange2 = async (
    name: string,
    value: any,
    data: any
  ) => {
    if (!data) {
      console.error("Data is undefined or null");
      return;
    }

    if (name === "stage") {
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          ["id"]: data?._id,
          ["stage"]: value,
        },
      }));
      try {
        // setApiResponse(true);
        // const response = await changeStage(body);
        // tableDataShowHandler();
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }

    if (name === "assignTo") {
      // const body = {

      // };
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          ["id"]: data?._id,
          ["AssignTo"]: value?.id,
        },
      }));
      // console.log(body, "body");
      try {
        setApiResponse(true);
        // const response = await changeAt(body);

        // tableDataShowHandler();
      } catch (error: any) {
        setApiResponse(false);
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
    if (name === "source") {
      setPersonalDetailState((prevFormData: any) => ({
        ...prevFormData,
        [name]: {
          ["id"]: data?._id,
          ["source"]: value,
        },
      }));
    }
  };

  const handleAction = (action: string) => {
    console.log(action, selectedRow);
    setAnchorEl(null);
  };

  const handleMenuClick = (
    event: React.MouseEvent<HTMLElement>,
    rowData: any
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(rowData);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const getCode = (dt: any, i: any) => {
    let txt = ``;
    const valName = dt?.name;

    switch (dt?.type) {
      case "text":
        return (
          <Grid item xs={4}>
            <Box>
              <CustomInput
                label={dt?.name ? dt?.name : dt?.type}
                placeHolder={dt?.placeholder ? dt?.placeholder : dt.type}
                onChange={(event: any) => {
                  let tempList = formFiels.fieldData;
                  let obj = tempList[i];
                  obj = { ...obj, answer: event.target.value };
                  tempList[i] = obj;

                  setFormFielsAns((prevFormDataFields: any) => ({
                    ...prevFormDataFields,

                    tempList,
                  }));
                }}
                value={dt.answer || ""}
                name={dt?.name ? dt?.name : dt?.type}
                type="text"
              />
            </Box>
          </Grid>
        );
        break;
      case "radio":
        return (
          <Grid item xs={4}>
            {/* <Box>

          <label>{dt.name}: </label>
          {dt.options.split(";").map((e: any) => {
            return <><input type="radio" value={e} placeholder={dt.placeholder} {...register(dt.name, { 'required': dt.required })} /><label>{e} </label></>
          })}
          {errors[dt.name] && (
            <Typography>This is required.</Typography>
          )}
          </Box> */}
            <FormControl>
              <FormLabel id="demo-radio-buttons-group-label">
                {dt?.name}
              </FormLabel>
              <RadioGroup
                onChange={(event) => {
                  let tempList = formFiels.fieldData;
                  let obj = tempList[i];
                  obj = {
                    ...obj,
                    answer: event.target.defaultValue,
                  };
                  tempList[i] = obj;

                  setFormFielsAns((prevFormDataFields: any) => ({
                    ...prevFormDataFields,
                    tempList,
                  }));
                }}
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                value={dt.answer || ""}
              >
                {dt.options.split(";").map((e: any, i: any) => {
                  return (
                    <>
                      <FormControlLabel
                        value={e}
                        control={<Radio />}
                        label={e}
                      />
                    </>
                  );
                })}
              </RadioGroup>
            </FormControl>
          </Grid>
        );
        break;
      case "select":
        return (
          <Grid item xs={4}>
            <Box>
              <label htmlFor="State" style={classes.label}>
                {dt?.name}
              </label>
              <Autocomplete
                disableClearable
                // value={personalDetailState?.[dt?.name]?.value ?? ""}
                value={dt.answer || ""}
                inputValue={dt.answer || ""}
                // inputValue={personalDetailState?.[dt?.name]?.value ?? ""}

                onChange={(event: any, newValue: string | null) => {
                  let tempList = formFiels.fieldData;
                  let obj = tempList[i];
                  obj = { ...obj, answer: event.target.innerText };
                  tempList[i] = obj;

                  setFormFielsAns((prevFormDataFields: any) => ({
                    ...tempList,
                  }));
                }}
                id="controllable-states-demo"
                options={dt.options.split(";").map((e: any) => {
                  return { label: e };
                })}
                sx={classes.autocomplateStyle}
                renderInput={(params) => (
                  <TextField
                    sx={
                      personalDetailState?.projecttypeId?.value
                        ? classes.autoInputFill
                        : classes.autoInputBlank
                    }
                    {...params}
                    // helperText={personalDetailState?.projecttypeId?.error}
                    // value={!!personalDetailState?.[dt?.name]?.value}
                    value={dt.answer || ""}
                    placeholder="select your ans"
                    
                  />
                )}
                renderOption={(props, option) => {
                  return (<>
                  {console.log(option)}
                    <li {...props} style={{fontSize:"14px"}}>
                      <span style={{ display: "none" }}>{option.label}</span>
                      {option.label}
                    </li>
                  </>
                  );
                }}
              />
            </Box>
            {/* <Box>

          <label>{dt.name}: </label>
          <select {...register(dt.name, { required: dt.required })}>
            {dt.options.split(";").map((e: any) => {
              return <option value={e}>{e}</option>
            })}
          </select>
          {errors[dt.name] && (
            <Typography>This is required.</Typography>
          )}
          </Box> */}
          </Grid>
        );
        break;
      case "checkbox":
        return (
          <Grid item xs={4}>
            {/* <Box>

          <label>{dt.name}: </label>
          <input type="checkbox" placeholder={dt.placeholder} {...register(dt.name, { 'required': dt.required })} />
          {errors[dt.name] && (
            <Typography>This is required.</Typography>
          )}
          </Box> */}
            <label>{dt.name} </label>
            <Checkbox
              checked={personalDetailState?.[dt?.name]?.value}
              onChange={(event: any) => {
                let tempList = formFiels.fieldData;
                let obj = tempList[i];
                obj = { ...obj, answer: event.target?.checked ? true : false };
                tempList[i] = obj;

                setFormFiels((prevFormDataFields: any) => ({
                  ...prevFormDataFields,

                  tempList,
                }));
              }}
              value={dt.answer || ""}
              inputProps={{ "aria-label": "controlled" }}
            />
          </Grid>
        );
        break;
      case "textarea":
        return (
          <Grid item xs={4}>
            {/* <Box>
              <label>{dt.name}: </label>
              <textarea {...register(dt.name, { required: dt.required })} />
              {errors[dt.name] && <Typography>This is required.</Typography>}
            </Box> */}
            <label> {dt?.name}</label>
            <TextareaAutosize
              minRows={4}
              value={personalDetailState?.[dt?.name]?.value}
              onChange={(event) => {
                let tempList = formFiels.fieldData;
                let obj = tempList[i];
                obj = { ...obj, answer: event.target.value };
                tempList[i] = obj;

                setFormFielsAns((prevFormDataFields: any) => ({
                  tempList,
                }));
              }}
            />
          </Grid>
        );
        break;
      default:
        txt += "";
    }
    return txt;
  };

  // const list = (anchor: "right") => (
  //   <>
  //     <Box sx={{ width: 1000 }} role="presentation">
  //       <Typography sx={{ padding: 2 }}>Create Task</Typography>
  //     </Box>
  //     <Box sx={{ padding: 2 }}>
  //       <Grid item xs={12} lg={12}>
  //         <Grid container rowSpacing={3} columnSpacing={5}>
  //           <Grid item xs={6}>
  //             <Box>
  //               <label
  //                 htmlFor="MaritalStatus"
  //                 style={classes.nameLeadDetailSide}
  //               >
  //                 Task Type <span style={{ color: "red" }}>*</span>
  //               </label>
  //               <CustomInput
  //                 placeHolder="Task Type"
  //                 onChange={handleOnChangeInputField}
  //                 name="Task Type"
  //                 type="text"
  //               />
  //             </Box>
  //           </Grid>

  //           <Grid item xs={6}>
  //             <Box>
  //               <label
  //                 htmlFor="MaritalStatus"
  //                 style={classes.nameLeadDetailSide}
  //               >
  //                 Ref
  //               </label>

  //             </Box>
  //           </Grid>
  //           <Grid item xs={6}>
  //             <Box>
  //               <label
  //                 htmlFor="MaritalStatus"
  //                 style={classes.nameLeadDetailSide}
  //               >
  //                 Priority
  //               </label>
  //               <Autocomplete
  //                 disabled
  //                 disableClearable
  //                 value={personalDetailState.developer_name ?? ""}
  //                 inputValue={personalDetailState.developer_name ?? ""}
  //                 id="controllable-states-demo"
  //                 options={[""]}
  //                 sx={classes.autocomplateStyle}
  //                 renderInput={(params) => (
  //                   <TextField
  //                     sx={
  //                       personalDetailState?.developerId?.value
  //                         ? classes.autoInputFill
  //                         : classes.autoInputBlank
  //                     }
  //                     {...params}
  //                     helperText={personalDetailState?.developer_name?.error}
  //                     error={
  //                       !!personalDetailState?.developer_name?.error?.length
  //                     }
  //                     value={!!personalDetailState.developer_name}
  //                     placeholder=""
  //                   />
  //                 )}
  //                 renderOption={(props, option) => {
  //                   return (
  //                     <li {...props}>
  //                       <span style={{ display: "none" }}>{option.id}</span>
  //                       {option.label}
  //                     </li>
  //                   );
  //                 }}
  //               />
  //             </Box>
  //           </Grid>
  //           <Grid item xs={6}>
  //             <Box>
  //               <label
  //                 htmlFor="MaritalStatus"
  //                 style={classes.nameLeadDetailSide}
  //               >
  //                 Description
  //               </label>
  //               <Autocomplete
  //                 disabled
  //                 disableClearable
  //                 value={personalDetailState.developer_name ?? ""}
  //                 inputValue={personalDetailState.developer_name ?? ""}
  //                 id="controllable-states-demo"
  //                 options={[""]}
  //                 sx={classes.autocomplateStyle}
  //                 renderInput={(params) => (
  //                   <TextField
  //                     sx={
  //                       personalDetailState?.developerId?.value
  //                         ? classes.autoInputFill
  //                         : classes.autoInputBlank
  //                     }
  //                     {...params}
  //                     helperText={personalDetailState?.developer_name?.error}
  //                     error={
  //                       !!personalDetailState?.developer_name?.error?.length
  //                     }
  //                     value={!!personalDetailState.developer_name}
  //                     placeholder=""
  //                   />
  //                 )}
  //                 renderOption={(props, option) => {
  //                   return (
  //                     <li {...props}>
  //                       <span style={{ display: "none" }}>{option.id}</span>
  //                       {option.label}
  //                     </li>
  //                   );
  //                 }}
  //               />
  //             </Box>
  //           </Grid>
  //           <Grid item xs={6}>
  //             <Box>
  //               <label
  //                 htmlFor="MaritalStatus"
  //                 style={classes.nameLeadDetailSide}
  //               >
  //                 Start Date
  //               </label>
  //               <Autocomplete
  //                 disabled
  //                 disableClearable
  //                 value={personalDetailState.developer_name ?? ""}
  //                 inputValue={personalDetailState.developer_name ?? ""}
  //                 id="controllable-states-demo"
  //                 options={[""]}
  //                 sx={classes.autocomplateStyle}
  //                 renderInput={(params) => (
  //                   <TextField
  //                     sx={
  //                       personalDetailState?.developerId?.value
  //                         ? classes.autoInputFill
  //                         : classes.autoInputBlank
  //                     }
  //                     {...params}
  //                     helperText={personalDetailState?.developer_name?.error}
  //                     error={
  //                       !!personalDetailState?.developer_name?.error?.length
  //                     }
  //                     value={!!personalDetailState.developer_name}
  //                     placeholder=""
  //                   />
  //                 )}
  //                 renderOption={(props, option) => {
  //                   return (
  //                     <li {...props}>
  //                       <span style={{ display: "none" }}>{option.id}</span>
  //                       {option.label}
  //                     </li>
  //                   );
  //                 }}
  //               />
  //             </Box>
  //           </Grid>
  //           <Grid item xs={6}>
  //             <Box>
  //               <label
  //                 htmlFor="MaritalStatus"
  //                 style={classes.nameLeadDetailSide}
  //               >
  //                 Status
  //               </label>
  //               <Autocomplete
  //                 disabled
  //                 disableClearable
  //                 value={personalDetailState.developer_name ?? ""}
  //                 inputValue={personalDetailState.developer_name ?? ""}
  //                 id="controllable-states-demo"
  //                 options={[""]}
  //                 sx={classes.autocomplateStyle}
  //                 renderInput={(params) => (
  //                   <TextField
  //                     sx={
  //                       personalDetailState?.developerId?.value
  //                         ? classes.autoInputFill
  //                         : classes.autoInputBlank
  //                     }
  //                     {...params}
  //                     helperText={personalDetailState?.developer_name?.error}
  //                     error={
  //                       !!personalDetailState?.developer_name?.error?.length
  //                     }
  //                     value={!!personalDetailState.developer_name}
  //                     placeholder=""
  //                   />
  //                 )}
  //                 renderOption={(props, option) => {
  //                   return (
  //                     <li {...props}>
  //                       <span style={{ display: "none" }}>{option.id}</span>
  //                       {option.label}
  //                     </li>
  //                   );
  //                 }}
  //               />
  //             </Box>
  //           </Grid>
  //           <Grid item xs={6}>
  //             <Box>
  //               <label
  //                 htmlFor="MaritalStatus"
  //                 style={classes.nameLeadDetailSide}
  //               >
  //                 Action
  //               </label>
  //               <Autocomplete
  //                 disabled
  //                 disableClearable
  //                 value={personalDetailState.developer_name ?? ""}
  //                 inputValue={personalDetailState.developer_name ?? ""}
  //                 id="controllable-states-demo"
  //                 options={[""]}
  //                 sx={classes.autocomplateStyle}
  //                 renderInput={(params) => (
  //                   <TextField
  //                     sx={
  //                       personalDetailState?.developerId?.value
  //                         ? classes.autoInputFill
  //                         : classes.autoInputBlank
  //                     }
  //                     {...params}
  //                     helperText={personalDetailState?.developer_name?.error}
  //                     error={
  //                       !!personalDetailState?.developer_name?.error?.length
  //                     }
  //                     value={!!personalDetailState.developer_name}
  //                     placeholder=""
  //                   />
  //                 )}
  //                 renderOption={(props, option) => {
  //                   return (
  //                     <li {...props}>
  //                       <span style={{ display: "none" }}>{option.id}</span>
  //                       {option.label}
  //                     </li>
  //                   );
  //                 }}
  //               />
  //             </Box>
  //           </Grid>
  //         </Grid>
  //         <Box sx={{ padding: "5px" }}>
  //           <label htmlFor="MaritalStatus" style={classes.nameLeadDetailSide}>
  //             Description
  //           </label>
  //           <TextField
  //             placeholder="Description"
  //             variant="outlined"
  //             fullWidth
  //             multiline
  //             sx={{
  //               height: "150px",
  //             }}
  //           />
  //         </Box>
  //         <Box>
  //           <CustomButton
  //             label={"save"}
  //             onClick={() => handleButtonClickleads("Next")}
  //             buttonType="primaryBtn"
  //             customClasses={classes.periousNextstyle}
  //           />
  //         </Box>
  //       </Grid>
  //     </Box>
  //   </>
  // );

  const columns: GridColDef[] = [
    {
      headerName: "Ref No",
      field: "refNum",
      minWidth: 100,
      disableColumnMenu: true,
      sortable: false,
      flex: 0.5,
      renderHeader: () => (
        <Typography sx={classes.nameLeadDetailSide}>Ref No</Typography>
      ),
      renderCell: (params) => (
        <Typography sx={classes.paraNameLeadDetailSide}>
          {params?.value}
        </Typography>
      ),
    },

    {
      headerName: "Priority",
      field: "priority",
      minWidth: 100,
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
      renderHeader: () => (
        <Typography sx={classes.nameLeadDetailSide}>Priority</Typography>
      ),
      renderCell: (params) => (
        <Typography sx={classes.paraNameLeadDetailSide}>
          {params.value}
        </Typography>
      ),
    },
    {
      headerName: "Assigned From",
      field: "assignedFrom",
      minWidth: 150,
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
      renderHeader: () => (
        <Typography sx={classes.nameLeadDetailSide}>
          Assigned From
        </Typography>
      ),
      renderCell: (params: GridRenderCellParams) => {
     
        return (
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
              <Typography sx={classes.paraNameLeadDetailSide}>
                {params.row.assignedFrom}
              </Typography>
        
          </Stack>
        );
      },
    },
    {
      headerName: "Assigned To Member",
      field: "assignToMember",
      minWidth: 200,
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
      renderHeader: () => (
        <Typography sx={classes.nameLeadDetailSide}>
          Assigned To Member
        </Typography>
      ),
      renderCell: (params: GridRenderCellParams) => {
        const assignToArray = JSON.parse(params.row.assignToMember || "[]");

        const assignedNames = assignToArray
          .map((id: string) => {
            const member = leadOptionMembers?.find(
              (teamMember: any) => teamMember.id === id
            );
            return member?.label || "Unknown";
          })
          .filter((name: any) => name !== "Unknown");

        return (
          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
          >
            {assignedNames.map((name: any, index: any) => (
              <Typography key={index} sx={classes.paraNameLeadDetailSide}>
                {name}
              </Typography>
            ))}
          </Stack>
        );
      },
    },
    {
      headerName: "Assigned To",
      field: "assignTo",
      minWidth: 100,
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
      renderHeader: () => (
        <Typography sx={classes.nameLeadDetailSide}>Assigned To</Typography>
      ),
      renderCell: (params: GridRenderCellParams) => {
        const assignToArray = JSON.parse(params.row.assignTo || "[]");

        const assignedNames = assignToArray
          .map((id: string) => {
            const member = leadOption?.find(
              (teamMember: any) => teamMember.id === id
            );
            return member?.label || "Unknown";
          })
          .filter((name: any) => name !== "Unknown");

        return (
          <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          {/* {assignedNames.map((name: any, index: number) => (
            <Typography key={index} sx={classes.paraNameLeadDetailSide}>
              {Array.isArray(name) ? name.join(", ") : name}
            </Typography>
          ))} */}
           <Typography  sx={classes.paraNameLeadDetailSide}>
          {assignedNames.join(', ')}
          </Typography>
        </Stack>
        
        );
      },
    },
 


    {
      headerName: "Description",
      field: "description",
      minWidth: 150,
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
      renderHeader: () => (
        <Typography sx={classes.nameLeadDetailSide}>Description</Typography>
      ),
      renderCell: (params) => (
        <Typography sx={classes.paraNameLeadDetailSide}>
          {params.value}
        </Typography>
      ),
    },

    {
      headerName: "Due Date",
      field: "dueDate",
      minWidth: 100,
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
      renderHeader: () => (
        <Typography sx={classes.nameLeadDetailSide}>DueDate</Typography>
      ),
      renderCell: (params) => (
        <Typography sx={classes.paraNameLeadDetailSide}>
          {params.value}
        </Typography>
      ),
    },
    {
      headerName: "Closed Date",
      field: "closedDate",
      minWidth: 100,
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
      renderHeader: () => (
        <Typography sx={classes.nameLeadDetailSide}>ClosedDate</Typography>
      ),
      renderCell: (params) => (
        <Typography sx={classes.paraNameLeadDetailSide}>
          {params.value}
        </Typography>
      ),
    },
    // {
    //   headerName: "Action",
    //   field: "action",
    //   minWidth: 100,
    //   flex: 0.5,
    //   disableColumnMenu: true,
    //   sortable: false,
    //   renderHeader: () => (
    //     <Typography sx={classes.nameLeadDetailSide}>Action</Typography>
    //   ),
    //   renderCell: (params: any) => {
    //     return (
    //       <IconButton onClick={(event) => createTask()} size="small">
    //         <MoreVertIcon />
    //       </IconButton>
    //     );
    //   },
    // },
  ];

  const columnsReminder: GridColDef[] = [
    {
      headerName: "S.No",
      field: "sno",
      minWidth: 5,
      disableColumnMenu: true,
      sortable: false,
      flex: 0.2,
      renderHeader: () => (
        <Typography sx={classes.nameLeadDetailSide}>S.No</Typography>
      ),
      valueGetter: (params) => {
        const sortedRowIds = params.api.getSortedRowIds();
        return sortedRowIds.indexOf(params.id) + 1;
      },
      renderCell: (params) => (
        <Typography sx={classes.paraNameLeadDetailSide}>
          {params.value}
        </Typography>
      ),
    },

    {
      headerName: selectedTab === 4 ? "Notes" : "Title",
      field: selectedTab === 4 ? "notes" : "title",
      minWidth: 10,
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
      renderHeader: () => (
        <Typography sx={classes.nameLeadDetailSide}>
          {selectedTab === 4 ? "Notes" : "Title"}
        </Typography>
      ),
      renderCell: (params) => (
        <Typography sx={classes.paraNameLeadDetailSide}>
          {params.value}
        </Typography>
      ),
    },
    // {
    //   headerName: "Created By",
    //   field: "CdateCreated",
    //   minWidth: 10,
    //   flex: 0.5,
    //   disableColumnMenu: true,
    //   sortable: false,
    //   renderHeader: () => (
    //     <Typography sx={classes.nameLeadDetailSide}>Created By</Typography>
    //   ),
    // },
    {
      headerName: "Updated By",
      field: selectedTab === 4 ? "updatedBy" : "user_name",
      // field: "user_name",
      minWidth: 10,
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
      renderHeader: () => (
        <Typography sx={classes.nameLeadDetailSide}>Updated By</Typography>
      ),
      renderCell: (params) => (
        <Typography sx={classes.paraNameLeadDetailSide}>
          {params.value}
        </Typography>
          //   <Typography sx={classes.nameLeadDetailSide}>
          //   {selectedTab === 4 ? "Notes" : "Title"}
          // </Typography>
      ),
    },
    {
      headerName: "Date Created",
      field: "date",
      minWidth: 10,
      flex: 0.5,
      disableColumnMenu: true,
      sortable: false,
      renderHeader: () => (
        <Typography sx={classes.nameLeadDetailSide}>Date Created</Typography>
      ),
      renderCell: (params) => (
        <Typography sx={classes.paraNameLeadDetailSide} >
          {params.row.date || "NA"}
          <br></br>
          {params.row.time}
        </Typography>
      ),
    },
  ];
    const normalizePhoneNumber = (phone:any) => {
  if (!phone) return '';
  
  const digitsOnly = phone.replace(/\D/g, '');

 
  if (digitsOnly.startsWith('91') && digitsOnly.length === 12) {
    return `+${digitsOnly}`;
  }

  if (digitsOnly.length === 10) {
    return `+91${digitsOnly}`;
  }

  return `+${digitsOnly}`;
};
    const handleClickToCall = async() =>{
      const payload = {
        leadPhone : normalizePhoneNumber(personalDetailState.leadPhone),
        uuid: store.getState().auth.uuid
      }
      console.log(payload,"click2calll")
      const response = await clickToCall(payload)
    }

  return (
    <>
    {/* <Grid style={{height:"100vh",overflow:"hidden"}}> */}
      <Box
        sx={{
          ...classes.profilePart,
          ...(props.hideNavHeader
            ? { height: "100%", minHeight: 0 }
            : null),
        }}
      >
        <Box sx={classes.leftSection}>
          <Box sx={classes.cardProfile}>
            <Box sx={classes.profileNamePart}>
              <Typography sx={classes.profileNameBg}>{firstLetter}</Typography>
              <Typography sx={classes.profileNamenew}>
                {splitLeadName[0]} {splitLeadName[1]}
              </Typography>
            </Box>
            <Box style={{ marginLeft: "63px" }}>
              <Box sx={classes.emailUid}>{personalDetailState.uid}</Box>
              <Box sx={classes.iconLayout} >
                {/* <DescriptionIcon className="iconAll" /> */}
                {/* <PhoneOutlinedIcon className="iconAll" /> */}
                <a onClick={handleClickToCall} style={{cursor:"pointer"}}
                  // href={`tel:${personalDetailState.leadPhone}`}
                  // aria-label="Call"
                >
                  <PhoneOutlinedIcon className="iconAll" />
                </a>

                <a
                  // href={`https://wa.me/${personalDetailState.leadPhone}`}
                  // href={`https://wa.me/91${personalDetailState.leadPhone}`}
                  // aria-label="WhatsApp"
                  // target="_blank"
                  // rel="noopener noreferrer"
                  onClick={handleClickToCall} style={{cursor:"pointer"}}
                >
                  <WhatsAppIcon className="iconAll" />
                </a>
                {/* <WhatsAppIcon className="iconAll" /> */}
              </Box>
            </Box>
          </Box>
          <Box>
            <Typography sx={classes.leadDetails}>Lead Form Details</Typography>
          </Box>
          <Box>
            {/* <Grid container>
      <Grid item > */}
            <Box sx={classes.spacing}>
              <Box sx={classes.singleRow}>
                <Box style={{ width: "50%" }}>
                  <Typography sx={classes.nameLeadDetailSide}>
                    Form Name
                  </Typography>
                  <Typography sx={classes.paraNameLeadDetailSide}>
                    {personalDetailState.form_name}
                  </Typography>
                </Box>

                <Box style={{ width: "50%" }}>
                  <Typography sx={classes.nameLeadDetailSide}>
                    Developer Name
                  </Typography>
                  <Typography sx={classes.paraNameLeadDetailSide}>
                    {personalDetailState.developer_name}
                  </Typography>
                </Box>
              </Box>

              <Box sx={classes.singleRow}>
                <Box mt={1} style={{ width: "50%" }}>
                  <Typography sx={classes.nameLeadDetailSide}>
                    Project Name
                  </Typography>
                  <Typography sx={classes.paraNameLeadDetailSide}>
                    {personalDetailState.project_name}
                  </Typography>
                </Box>
                <Box mt={1} style={{ width: "50%" }}>
                  <Typography sx={classes.nameLeadDetailSide}>
                    Project Type
                  </Typography>
                  <Typography sx={classes.paraNameLeadDetailSide}>
                    {personalDetailState.projecttype_name}
                  </Typography>
                </Box>
              </Box>
              <Box sx={classes.singleRow}>
                <Box mt={1}>
                  <Typography sx={classes.nameLeadDetailSide}>
                    Lead Source
                  </Typography>
                  <Typography sx={classes.paraNameLeadDetailSide}>
                    {personalDetailState.source}
                  </Typography>
                </Box>
              </Box>
            </Box>
            {/* </Grid>
    </Grid> */}
          </Box>
          <Divider sx={{ mt: 1, borderColor: "#ccc" }} />
          <Box sx={classes.spacing}>
            <Box>
              <Typography sx={classes.nameLeadDetailSide}>Full Name</Typography>
              <Typography sx={classes.paraNameLeadDetailSide}>
                {personalDetailState.leadName}
              </Typography>
            </Box>
            <Box mt={1}>
              <Typography sx={classes.nameLeadDetailSide}>Email</Typography>
              <Typography sx={classes.paraNameLeadDetailSide}>
                {personalDetailState.leadEmail}
              </Typography>
            </Box>
            <Box mt={1}>
              <Typography sx={classes.nameLeadDetailSide}>
                Phone Number
              </Typography>
              <Typography sx={classes.paraNameLeadDetailSide}>
                {personalDetailState.leadPhone}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box sx={classes.tabSection}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange2}
            aria-label="Tabs example"
          >
            <Tab label="Activities" />
            <Tab label="Lead Details" />
            <Tab label="Task" />
            <Tab label="Reminder" />
            <Tab label="Notes" />
            {/* <Tab label="Documents" /> */}
          </Tabs>
          {/* Activity */}
          <Box hidden={selectedTab !== 0}>
  <Timeline
    sx={{
      ...classes.timeline,
      maxHeight: 'calc(100vh - 148px)', 
      overflowY: 'auto',  
      paddingRight: '16px', 
      scrollbarWidth:"thin",
      [`& .${timelineItemClasses.root}:before`]: {
        flex: 0,
        padding: 0,
      },
    }}
  >
    {((leadHistory && leadHistory) || [])
    // filter((val: any) => props.type !== "MyLead" || val.userId === store.getState().auth.userId)
      .map((history: any) => (
        <TimelineItem key={history._id}>
          <TimelineSeparator>
            <TimelineDot
              variant="outlined"
              sx={{
                borderColor: "#3D48E5",
                borderWidth: 2,
                width: 10,
                height: 10,
                backgroundColor: "transparent",
              }}
            />
            <TimelineConnector sx={{ height: "50px" }} />
          </TimelineSeparator>
          <TimelineContent>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                {history.new_value}
              </span>
              {history.users?.[0]?.name ? 
              <span
                style={{
                  marginTop: "4px",
                  fontSize: "12px",
                  color: "gray",
                }}
              >
                Lead status changed by {history.users?.[0]?.name}
              </span>
              :""}
              <span
                style={{
                  marginTop: "4px",
                  fontSize: "12px",
                  color: "gray",
                }}
              >
                {new Date(history.updatedAt).toLocaleString()}
              </span>
            </div>
          </TimelineContent>
        </TimelineItem>
      ))}
  </Timeline>

  {/* Uncomment this section if you want to display "More Status" */}
  {/* {leadHistory && leadHistory?.length > 2 && (
    <Typography>
      <a
        style={{
          color: "blue",
          fontSize: "12px",
          textDecoration: "underline",
          cursor: "pointer",
        }}
        onClick={() => setShowAll(true)}
      >
        More Status
      </a>
    </Typography>
  )} */}
</Box>

        
          {/* Lead Details */}
          <Box sx={classes.tabContent2} hidden={selectedTab !== 1}>
            <Box style={{height:"100vh"}}>
            <Grid item>
              <Typography sx={classes.leadDetails}>
                Lead Form Details
              </Typography>
            </Grid>
            <Grid item xs={14}>
              <Typography sx={classes.HeadingForm}>Add New Lead</Typography>
            </Grid>
            <Grid>
              <Box sx={{ width: "50%" }}>
                <label htmlFor="MaritalStatus" style={classes.label}>
                  Form Name
                </label>
                <Autocomplete
                  disableClearable
                  disabled
                  value={personalDetailState?.formId?.value}
                  inputValue={personalDetailState?.form_name ?? ""}
                  onChange={(event: any, newValue: string | null) => {
                    handleAutocompleteChange("formId", newValue || "");
                  }}
                  id="controllable-states-demo"
                  options={formName}
                  sx={classes.autocomplateStyle}
                  renderInput={(params) => (
                    <TextField
                      sx={
                        personalDetailState?.developerId?.value
                          ? classes.autoInputFill
                          : classes.autoInputBlank
                      }
                      {...params}
                      helperText={personalDetailState?.formId?.error}
                      error={!!personalDetailState?.formId?.error?.length}
                      value={!!personalDetailState?.formId?.value}
                      placeholder="select your form name"
                    />
                  )}
                  renderOption={(props, option) => {
                    return (
                      <li {...props}>
                        <span style={{ display: "none" }}>{option.id}</span>
                        {option.label}
                      </li>
                    );
                  }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} lg={12}>
              {personalDetailState && (
                <Grid container rowSpacing={3} columnSpacing={5}>
                  <Grid item xs={4}>
                    <Box>
                      <label htmlFor="MaritalStatus" style={classes.label}>
                        Developer Name
                      </label>
                      <Autocomplete
                        disabled
                        disableClearable
                        value={personalDetailState.developer_name ?? ""}
                        inputValue={personalDetailState.developer_name ?? ""}
                        onChange={(event: any, newValue: string | null) => {
                          handleAutocompleteChange(
                            "developer_name",
                            newValue || ""
                          );
                        }}
                        id="controllable-states-demo"
                        options={[""]}
                        sx={classes.autocomplateStyle}
                        renderInput={(params) => (
                          <TextField
                            sx={
                              personalDetailState?.developerId?.value
                                ? classes.autoInputFill
                                : classes.autoInputBlank
                            }
                            {...params}
                            helperText={
                              personalDetailState?.developer_name?.error
                            }
                            error={
                              !!personalDetailState?.developer_name?.error
                                ?.length
                            }
                            value={!!personalDetailState.developer_name}
                            placeholder=""
                          />
                        )}
                        renderOption={(props, option) => {
                          return (
                            <li {...props}>
                              <span style={{ display: "none" }}>
                                {option.id}
                              </span>
                              {option.label}
                            </li>
                          );
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box>
                      <label htmlFor="ProjectName" style={classes.label}>
                        Project Name
                      </label>
                      <Autocomplete
                        disabled
                        disableClearable
                        value={personalDetailState?.projectId ?? ""}
                        inputValue={personalDetailState?.project_name ?? ""}
                        onChange={(event: any, newValue: string | null) => {
                          handleAutocompleteChange("projectId", newValue || "");
                        }}
                        id="controllable-states-demo"
                        options={["projectList"]}
                        sx={classes.autocomplateStyle}
                        renderInput={(params) => (
                          <TextField
                            sx={
                              personalDetailState?.projectId?.value
                                ? classes.autoInputFill
                                : classes.autoInputBlank
                            }
                            {...params}
                            helperText={personalDetailState?.projectId?.error}
                            error={
                              !!personalDetailState?.projectId?.error?.length
                            }
                            value={!!personalDetailState?.projectId?.value}
                            placeholder="select your project name"
                          />
                        )}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={4}>
                    <Box>
                      <label htmlFor="State" style={classes.label}>
                        Property Type
                      </label>
                      <Autocomplete
                        disabled
                        disableClearable
                        value={personalDetailState?.projecttype_name ?? ""}
                        onChange={(event: any, newValue: string | null) => {
                          handleAutocompleteChange(
                            "projecttypeId",
                            newValue || ""
                          );
                        }}
                        id="controllable-states-demo"
                        options={["type"]}
                        sx={classes.autocomplateStyle}
                        renderInput={(params) => (
                          <TextField
                            sx={
                              personalDetailState?.projecttypeId?.value
                                ? classes.autoInputFill
                                : classes.autoInputBlank
                            }
                            {...params}
                            helperText={
                              personalDetailState?.projecttypeId?.error
                            }
                            value={!!personalDetailState?.projecttypeId?.value}
                            placeholder="select your property type"
                          />
                        )}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={4}></Grid>
                  <Grid item xs={12}>
                    <Divider></Divider>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography sx={classes.HeadingForm}>
                      Lead Details
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Box>
                      <CustomInput
                        label="Name"
                        placeHolder="Enter Name"
                        // helperText={personalDetailState?.data[0]?.leadName}
                        // error={!!personalDetailState?.data[0]?.leadName?.error?.length}
                        value={personalDetailState?.leadName}
                        onChange={handleOnChangeInputField}
                        name="leadName"
                        type="text"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box>
                      <CustomInput
                        label="Work Email"
                        placeHolder="xyz@xyz.com"
                        helperText={personalDetailState?.leadEmail?.error}
                        error={!!personalDetailState?.leadEmail?.error?.length}
                        value={personalDetailState?.leadEmail}
                        onChange={handleOnChangeInputField}
                        name="leadEmail"
                        type="text"
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box>
                      <CustomInput
                        label="Phone Number"
                        placeHolder="XXX XXX XXXX"
                        helperText={personalDetailState?.leadPhone?.error}
                        error={!!personalDetailState?.leadPhone?.error?.length}
                        value={personalDetailState?.leadPhone}
                        onChange={handleOnChangeInputField}
                        name="leadPhone"
                        type="number"
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={4}>
                    <Box>
                      <label htmlFor="State" style={classes.label}>
                        Stage
                      </label>
                      {/* <Autocomplete
                        disableClearable
                        value={personalDetailState?.stage}
                        onChange={(event: any, newValue: string | null) => {
                          handleAutocompleteChange2(
                            "stage",
                            newValue || "",
                            personalDetailState?.data
                          );
                        } }
                        id="controllable-states-demo"
                        options={stageData}
                        sx={classes.autocomplateStyle}
                        renderInput={(params) => (
                          <TextField
                            sx={classes.autoInputFill}
                            {...params}
                            placeholder="select your form name" />
                        )}
                        renderOption={(props, option) => {
                          return (
                            <li {...props}>
                              <span style={{ display: "none" }}>{option}</span>
                              {option}
                            </li>
                          );
                        } } /> */}

                      {/* ========================New Code==================================== */}

                      {/* <Autocomplete
                        disableClearable
                        // value={autocompleteValue}
                        value={
                          personalDetailState?.stage ?? ""
                        }
                        onChange={(
                          event: any,
                          newValue: { label: string; isParent: boolean } | null
                        ) => {
                          if (newValue && !newValue.isParent) {
                            //  setAutocompleteValue(newValue);
                            handleAutocompleteChange2(
                              "stage",
                              newValue || "",
                              personalDetailState?.data
                            );
                          }
                        }}
                        id="controllable-states-demo"
                        options={stageOptions}
                        getOptionLabel={(option) => option.label}
                        sx={classes.autocomplateStyle}
                        style={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField
                            sx={classes.autoInputFill}
                            {...params}
                            placeholder="Select your form name"
                          />
                        )}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            style={{
                              fontSize: "12px",
                              fontWeight: option.isParent ? "bold" : "normal",
                              marginLeft: option.isParent ? "0px" : "10px",
                              pointerEvents: option.isParent ? "none" : "auto",
                            }}
                          >
                            {option.label}
                          </li>
                        )}
                      /> */}

<Autocomplete
                    disableClearable
                    value={
                      personalDetailState?.stage || ""
                 
                    }
                    // inputValue={personalDetailState?.formId?.value ?? ""}
                    onChange={(event: any, newValue: string | null) => {
                      handleAutocompleteChange2(
                        "stage",
                        newValue || "",
                        personalDetailState?.data[0]
                      );
                    }}
                    id="controllable-states-demo"
                    options={stageOptions}
                    sx={customTableStyles.autocompleteStyle}
                    renderInput={(params) => (
                      <TextField
                        sx={classes.autoInputFill}
                        {...params}
                        // helperText={personalDetailState?.formId?.error}
                        // error={!!personalDetailState?.formId?.error?.length}
                        // value={!!personalDetailState?.formId?.value}
                        placeholder="Select stage"
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: option.isParent ? "bold" : "normal",
                          marginLeft: option.isParent ? "0px" : "10px",
                          pointerEvents: option.isParent ? "none" : "auto",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box>
                      <label htmlFor="State" style={classes.label}>
                        Source
                      </label>
                      <Autocomplete
                        disabled
                        disableClearable
                        value={personalDetailState?.source}
                        onChange={(event: any, newValue: string | null) => {
                          handleAutocompleteChange2(
                            "source",
                            newValue || "",
                            personalDetailState?.data
                          );
                        }}
                        id="controllable-states-demo"
                        options={stageSourse}
                        sx={customTableStyles.autocompleteStyle}
                        renderInput={(params) => (
                          <TextField sx={classes.autoInputFill} {...params} />
                        )}
                        renderOption={(props, option: any) => {
                          return <li {...props}>{option}</li>;
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={8}></Grid>
                  {(formFiels.fieldData || []).length > 1 ?
                  <><Grid item xs={12} lg={12}>
                      <Divider></Divider>
                    </Grid><Grid item xs={12} lg={12}>
                        <Typography sx={classes.HeadingForm}>
                          Additional Details
                        </Typography>
                      </Grid><Grid
                        container
                        spacing={3}
                        padding={"20px"}
                        paddingLeft={"40px"}
                      >
                        {formFiels.fieldData &&
                          formFiels?.fieldData?.map((e: any, i: any) => {
                            return getCode(e, i);
                          })}
                      </Grid></>
                  :""}

                  <Grid item xs={12} lg={12}>
                    <CustomButton
                      label={`${
                        personalDetailState?.formId ? "Edit & Save" : "Save "
                      }`}
                      onClick={submitForm}
                      buttonType="primaryBtn"
                      customClasses={classes.custombuttonStyle}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>

            </Box>
          </Box>
          {/* Task */}
          <Box sx={classes.tabContent2} hidden={selectedTab !== 2}>
            <Grid
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "end",
              }}
            >
              <Grid item xs={4} sm={2}>
                <CustomButton
                  buttonType="primaryBtn"
                  label="Add Tasks"
                  onClick={() => setTaskDrawer(true)}
                />
              </Grid>
            </Grid>

            <Box sx={{ height: "calc(100vh - 148px)" }}>
              <DataGridPro
                columns={columns}
                rows={taskData}
                getRowId={(row) => row.task_id}
                getRowHeight={() => "auto"}
                style={{ border: "none" }}
                localeText={{
                  noRowsLabel: "No data found",
                }}
              />
            </Box>
          </Box>
          {/* Reminder */}

          {/* <Box hidden={selectedTab !== 3} sx={classes.tabContent2}> */}

          {/* <Box hidden={selectedTab !== 3} sx={classes.tabContent2}>
              <Grid container justifyContent="flex-end">
                <CustomButton
                  label={"Create"}
                  onClick={createReminder}
                  buttonType="success"
                  customClasses={classes.periousNextstyle} />
              </Grid>
            
            </Box> */}
          {/* Reminder */}

          <Box hidden={selectedTab !== 3} sx={classes.tabContent2}>
            {/* <Grid container justifyContent="flex-end">
                <CustomButton
                  label={"Create"}
                  onClick={createReminder}
                  buttonType="success"
                  customClasses={classes.periousNextstyle} />
              </Grid> */}

            <Box sx={{ height: "calc(100vh - 148px)" }}>
              <DataGridPro
                columns={columnsReminder}
                rows={rowReminder}
                style={{ border: "none" }}
                getRowId={(row) => row._id}
                getRowHeight={() => 'auto'}
              />
            </Box>

            <Dialog
              open={openReminder}
              onClose={handleClose}
              aria-describedby="alert-dialog-slide-description"
              maxWidth="sm"
              fullWidth
            >
              <Box p={3}>
                <Typography variant="h6" gutterBottom>
                  Create Reminder
                </Typography>
                <Box mb={2}>
                  <Typography variant="subtitle1">Title</Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Enter reminder title"
                    value={titleReminder}
                    onChange={(e) => setTitleReminder(e.target.value)}
                  />
                </Box>
                <Box mb={2}>
                  <Typography variant="subtitle1">Date and Time</Typography>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Select date and time"
                    type="datetime-local"
                    value={dateTimeReminder}
                    onChange={(e) => setDateTimeReminder(e.target.value)}
                  />
                </Box>
                <Box mb={2}>
                  <Typography variant="subtitle1">
                    <b>Note</b> (Notes help you remember important details about
                    your leads.)
                  </Typography>
                  <TextareaAutosize
                    style={{
                      width: "100%",
                      minHeight: "100px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "8px",
                      fontSize: "16px",
                      resize: "none",
                    }}
                    placeholder="Enter notes"
                    value={noteReminder}
                    onChange={(e) => setNoteReminder(e.target.value)}
                  />
                </Box>
                <Box display="flex" justifyContent="flex-end">
                  <CustomButton
                    label={"Save"}
                    onClick={() => {
                      const body = {
                        date: dateTimeReminder.split("T")[0],
                        time: dateTimeReminder.split("T")[1],
                        title: titleReminder,
                        notes: noteReminder,
                        leadId: personalDetailState._id,
                      };
                      handelSideSave(body);
                    }}
                    buttonType="success"
                    customClasses={classes.periousNextstyle}
                  />
                </Box>
              </Box>
            </Dialog>
          </Box>
          {/* Notes */}
          <Box hidden={selectedTab !== 4} sx={classes.tabContent2}>
            {/* <Grid container justifyContent="flex-end">
                <CustomButton
                  label={"Create"}
                  onClick={createRemarkPop}
                  buttonType="success"
                  customClasses={classes.periousNextstyle} />
              </Grid> */}
            <Box style={{ height: "calc(100vh - 148px)" }}>
              <DataGridPro
                columns={columnsReminder}
                style={{ border: "none" }}
                rows={rowRemarks}
                getRowHeight={() => 'auto'}
                getRowId={(row) => row._id}
              />
            </Box>
            <Dialog
              open={openRemarkPop}
              onClose={handleClose}
              aria-describedby="alert-dialog-slide-description"
              maxWidth="sm"
              fullWidth
            >
              <Box p={3}>
                <Typography variant="h6" gutterBottom>
                  Create Note
                </Typography>

                <Box mb={2}>
                  <Typography variant="subtitle1">
                    <b>Note</b> (Notes help you remember important details about
                    your leads.)
                  </Typography>
                  <TextareaAutosize
                    style={{
                      width: "100%",
                      minHeight: "100px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "8px",
                      fontSize: "16px",
                      resize: "none",
                    }}
                    placeholder="Enter notes"
                    value={noteRemarkValue}
                    onChange={(e) => setnoteRemarkValue(e.target.value)}
                  />
                </Box>
                <Box display="flex" justifyContent="flex-end">
                  <CustomButton
                    label={"Save"}
                    onClick={() => {
                      const body = {
                        leadId: personalDetailState._id,
                        notes_remark: noteRemarkValue,
                      };
                      handelSideSaveRemark(body);
                    }}
                    buttonType="success"
                    customClasses={classes.periousNextstyle}
                  />
                </Box>
              </Box>
            </Dialog>
          </Box>
          {/* </Box> */}
        </Box>
        <Box sx={classes.rightSection}>
          <Box sx={classes.sideBoxWrapper}>
            {/* <LeadDetailsComponent
              dynamicGridValue={personalDetailState}
              handleAutocompleteChange={handleAutocompleteChangeNew}
              handleAutocompleteChangeCustom={handleAutocompleteChangeCustom}
              handleOptionCheckboxChange={handleOptionCheckboxChange}
              selectedOptions={selectedOptions}
              leadOption={leadOption}
              leadOptionMembers={leadOptionMembers}
              handleOptionCheckboxChange1={handleOptionCheckboxChange1}
              handleAssignToMember={handleAssignToMember}
              selectedOptionsMembers={selectedOptionsMembers}
              handleChangeRadio={handleChangeRadio}
              reminderStatus={reminderStatus}
              setReminderStatus={setReminderStatus}
              setReminderData={setReminderData}
              currentDateTime={currentDateTime}
              handleDateTimeChange={handleDateTimeChange}
              handelAssignToUser={handelAssignToUser}
              handelSideSave={handelSideSave}
              reminderData={reminderData}
              addinationalValue={props.addinationalValue}
              stageData={stageData}
              isMyLead={props.type === "MyLead" ? true : false}
              responseValueremark={responseValueremark}
              handelSideSaveRemark={handelSideSaveRemark}
              handelRemoveReminder={handelRemoveReminder}
              allSatgedata={allSatgedata}
              responseValuereminder={responseValuereminder}
              setSelectedTab={setSelectedTab}
              customerDetail = {true}
            /> */}
          </Box>
        </Box>
      </Box>

    {/* </Grid> */}
      <SwipeableDrawer
        anchor="right"
        style={{ zIndex: 1300 }}
        open={taskDrawer}
        onClose={() => closeDrawer()}
        onOpen={() => setTaskDrawer(true)}
      >
        <IconButton
          edge="start"
          color="inherit"
          onClick={() => closeDrawer()}
          style={{ position: "absolute", top: 10, right: 10 }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ width: 750 }} role="presentation">
          <Typography sx={CustomPageHeaderStyles.heading} p={2}>
            Create Task
          </Typography>
          <Divider />

          <Box p={2} sx={{ height: "calc(100vh - 123px)" }}>
            <Grid container spacing={2}>
              {/* <Grid item xs={12} lg={6}>
      <Box>
        <InputLabel sx={customInputStyles.nameField}>Ref #</InputLabel>

      </Box>
    </Grid> */}
              {/* <Grid item xs={12} lg={6}>

    </Grid> */}
              <Grid item xs={12} lg={12}>
                <InputLabel sx={customInputStyles.nameField}>
                  Priority
                </InputLabel>
                <Autocomplete
                  // disableCloseOnSelect
                  disableClearable
                  value={taskState?.priority ? taskState.priority : ""}
                  onChange={(event: any, newValue: string | null) => {
                    setTaskState({ ...taskState, priority: newValue });
                  }}
                  // inputValue={inputValue}
                  // onInputChange={(event, newInputValue) => {
                  //   setInputValue(newInputValue);
                  // }}
                  options={["Low", "Medium", "High"]}
                  sx={{
                    ...customTableClasses.autocompleteStyle,
                    zIndex: "1300",
                  }}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select" />
                  )}
                  renderOption={(props, option) => (
                    <li {...props} style={{ fontSize: "12px" }}>
                      {option}
                    </li>
                  )}
                />
                {errors.priority && (
                  <InputLabel sx={{ color: "red", fontSize: "12px" }}>
                    Priority is required
                  </InputLabel>
                )}
              </Grid>
              <Grid item xs={12} lg={6}>
                <Box>
                  <InputLabel sx={customInputStyles.nameField}>
                    Assign To
                  </InputLabel>

                  <Autocomplete
                    multiple
                    disableClearable
                    disableCloseOnSelect
                    limitTags={2}
                    value={selectedOptions}
                    // onChange={(event, newValue) =>
                    //   setTaskState({ ...taskState, assignTo: newValue })
                    // }
                    id="controllable-states-demo"
                    options={leadOption}
                    sx={customTableClasses.autocompleteStyle}
                    style={{ width: "100%" }}
                    getOptionLabel={(option: any) => option?.label}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // placeholder="Select options"
                        sx={classes.autoInputFill}
                      />
                    )}
                    renderOption={(props, option: any, { selected }, value) => (
                      <>
                        <li style={{ fontSize: "10px" }} {...props}>
                          <Checkbox
                            size="small"
                            style={{
                              fontSize: "10px",
                              height: "5px",
                              width: "5px",
                              marginRight: "10px",
                            }}
                            checked={option?.selected === 1}
                          />
                          {option?.label}
                        </li>
                      </>
                    )}
                  />
                </Box>
                {/* {errors.assignTo && (
                  <InputLabel sx={{ color: "red", fontSize: "12px" }}>
                    Assign To is required
                  </InputLabel>
                )} */}
              </Grid>
              <Grid item xs={12} lg={6}>
                <Box>
                  <InputLabel sx={customInputStyles.nameField}>
                    Assign To Member
                  </InputLabel>
                  <Autocomplete
                    multiple
                    disableClearable
                    disableCloseOnSelect
                    limitTags={2}
                    id="controllable-states-demo"
                    options={uniqueLeadOptionMembers}
                    value={
                      taskState?.assignToMember
                        ? uniqueLeadOptionMembers.filter((option: any) =>
                            taskState.assignToMember.includes(option.id)
                          )
                        : []
                    }
                    sx={customTableClasses.autocompleteStyle}
                    getOptionLabel={(option:any) => option.label}
                    onChange={(event, value) => {
                      const selectedIds = value.map((item: any) => item.id);
                      setTaskState((prev: any) => ({
                        ...prev,
                        assignToMember: selectedIds,
                      }));
                    }}
                    renderInput={(params) => <TextField {...params} />}
                    renderOption={(props, option:any) => (
                      <li {...props} style={{ fontSize: "10px" }}>
                        <Checkbox
                          style={{
                            fontSize: "10px",
                            height: "5px",
                            width: "5px",
                            marginRight: "10px",
                          }}
                          size="small"
                          checked={
                            taskState?.assignToMember?.includes(option.id) ||
                            false
                          }
                          onChange={() => handleCheckboxChange(option.id)}
                        />
                        {option.label}
                      </li>
                    )}
                  />
                  {/* <Autocomplete
      multiple
      disableClearable
      disableCloseOnSelect
      limitTags={2}
      id="controllable-states-demo"
      options={leadOptionMembers}
      sx={customTableClasses.autocompleteStyle}
      style={{ width: "100%" }}
      getOptionLabel={(option: any) => option?.label}
      renderInput={(params) => (
        <TextField
          {...params}
          // placeholder="Select options"
          sx={classes.autoInputFill}
        />
      )}
      renderOption={(props, option: any, { selected }, value) => (
        <>
          <li style={{ fontSize: "10px" }} {...props}>
            <Checkbox
              size="small"
              style={{
                fontSize: "10px",
                height: "5px",
                width: "5px",
                marginRight: "10px",
              }}
              onChange={(event, newValue) =>
                setTaskState({ ...taskState, assignToMember: option.id })
              }
            />
            {option?.label}
          </li>
        </>
      )}
    /> */}
                </Box>
                {errors.assignToMember && (
                  <InputLabel sx={{ color: "red", fontSize: "12px" }}>
                    Assign To Member is required
                  </InputLabel>
                )}
              </Grid>

              <Grid item xs={12} lg={6}>
                <Box>
                  <InputLabel sx={customInputStyles.nameField}>
                    Task Due Date
                  </InputLabel>
                  <Box
                   
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DateField"]}>
                        <DatePicker
                          slotProps={{
                            textField: {
                              sx: classes.dateField,
                            },
                          }}
                          value={
                            taskState.dueDate
                              ? dayjs(taskState.dueDate, "DD-MM-YYYY")
                              : null
                          }
                          onChange={(newValue: Dayjs | null) => {
                            setTaskState({
                              ...taskState,
                              dueDate: newValue
                                ? newValue.format("DD-MM-YYYY")
                                : null, // Update the date in the state
                            });
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} lg={6}>
                <Box>
                  <InputLabel sx={customInputStyles.nameField}>
                    Task Close Date
                  </InputLabel>
                  <Box
                   
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DateField"]}>
                        <DatePicker
                          //  value={taskState.closedDate ? new Date(taskState.closedDate) : null}
                          value={
                            taskState.closedDate
                              ? dayjs(taskState.closedDate, "DD-MM-YYYY")
                              : null
                          }
                          onChange={(newValue: Dayjs | null) => {
                            setTaskState({
                              ...taskState,
                              closedDate: newValue
                                ? newValue.format("DD-MM-YYYY")
                                : null, // Update the date in the state
                            });
                          }}
                          slotProps={{
                            textField: {
                              sx: classes.dateField,
                            },
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Box>
                </Box>
              </Grid>

              {/* <Grid item xs={12} lg={6}>
                <Box>
                  <InputLabel sx={customInputStyles.nameField}>
                    Description
                  </InputLabel>

                  <TextField
                    placeholder="Enter Description"
                    sx={classes.textField}
                    value={taskState?.description || ""}
                    onChange={(e) => {
                      setTaskState({
                        ...taskState,
                        description: e.target.value,
                      });
                    }}
                  />
                </Box>
              </Grid> */}

              <Grid item xs={12} lg={12}>
                <Box>
                  <InputLabel sx={{ ...customInputStyles.nameField }}>
                    Description
                  </InputLabel>

                  <TextField
                    fullWidth
                    multiline
                    value={taskState?.description || ""}
                    // label="Add Name"
                    placeholder="Hierarchy Description"
                    sx={LeadPersonalDetailsStyles.textArea}
                    id="fullWidth"
                    onChange={(e) => {
                      setTaskState({
                        ...taskState,
                        description: e.target.value,
                      });
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Divider />
          <Grid item xs={12} sx={classes.buttonFooter}>
            <Box>
              <CustomButton
                label="Cancel"
                onClick={() => closeDrawer()}
                buttonType="default"
                customClasses={classes.periousNextstyle}
              />
            </Box>
            <Box>
              <CustomButton
                label="Submit"
                onClick={() => handleSubmit()}
                buttonType="primaryBtn"
                customClasses={classes.periousNextstyle}
              />
            </Box>
          </Grid>
        </Box>
      </SwipeableDrawer>
    </>
  );
}

export default LeadPersonalDetails;
